<template>
  <div id="membershipPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="عضویت"></ActionBar>
    <div class="row container mx-auto p-0 mt-2">
      <div class="col-12 col-md-6 col-l-4 p-0 mb-4 mx-auto">
        <div class="member-ship-tab p-2 d-flex justify-space-between">
          <v-btn :class="{active: membershipHistory}" class=" px-lg-16" color="third" rounded
                 @click="showMemberShipHistory">سوابق عضویت
          </v-btn>
          <v-btn :class="{active: activeMembership}" class="px-7 px-lg-16" color="third" rounded
                 @click="showActiveMembership">عضویت فعال
          </v-btn>
        </div>
      </div>
    </div>
    <div v-if="membershipHistory">
      <div v-if="!hasPackages" class="row mx-2 mt-10 knowledge-base-body">
        <div class="col-12">
          <v-alert
              border="bottom"
              class="mt-4 text-center"
              color="forth"
              dark>
            شما پکیجی خریداری نکرده اید.
          </v-alert>
        </div>
      </div>
      <div v-else class="row container mx-auto p-0  mt-2">
        <div v-for="item in historyItems" :key="item.PackageInvoiceID" class="col-12  col-md-6 col-lg-4 header-rounded">
          <div class="third-background header-rounded white--text pt-2 mx-1"></div>
          <div class="row mx-1 bg-white  rounded-b-lg">
            <div class="col-12 p-4 d-flex mb-4"><img v-if="item.FileUrl !== null" :alt="item.Name"
                                                     :src="$replaceHttps(item.FileUrl)"
                                                     class="rounded-xl w-25 ">
              <div class="pt-7 pt-lg-8 pt-sm-16">{{ item.Name }}</div>
            </div>
            <table class="col-12">
              <tbody>
              <tr class="light-gray-top-border">
                <td class="p-1">تاریخ خرید</td>
                <td>{{ $convertDate(item.ModifiedDate) }}</td>
              </tr>
              <tr class="light-gray-top-border">
                <td class="p-1">نوع اشتراک</td>
                <td>نقره ای یک ماهه</td>
              </tr>
              <tr class="light-gray-top-border light-gray-bottom-border">
                <td class="p-1">تاریخ انقضا:</td>
                <td>{{ $convertDate(item.ExpireDate) }}</td>
              </tr>
              </tbody>
            </table>
            <div class="text-center col-12 ">
              <v-btn class="gradient-btn px-5" rounded small @click="goToPackageDetail(item.PackageID)">
                مشاهده و خرید
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="activeMembership">
      <div v-if="!hasActiveMembership" class="row mx-2 mt-10 knowledge-base-body">
        <div class="col-12">
          <v-alert
              border="bottom"
              class="mt-4 text-center"
              color="forth"
              dark>
            پکیج فعالی ندارید
          </v-alert>
        </div>
      </div>
      <div v-else class="row container mx-auto p-0  mt-2">
        <div v-for="item in items" :key="item.PackageInvoiceID" class="col-12  col-md-6 col-lg-4 header-rounded">
          <div class="third-background header-rounded white--text pt-2 mx-1"></div>
          <div class="row mx-1 bg-white  rounded-b-lg">
            <div class="col-12 p-4 d-flex mb-4"><img v-if="item.FileUrl !== null" :alt="item.Name"
                                                     :src="$replaceHttps(item.FileUrl)"
                                                     class="rounded-xl w-25 ">
              <div class="pt-7 pt-lg-8 pt-sm-16">{{ item.Name }}</div>
            </div>
            <table class="col-12">
              <tbody>
              <tr class="light-gray-top-border">
                <td class="p-1">تاریخ خرید</td>
                <td>{{ $convertDate(item.ModifiedDate) }}</td>
              </tr>
              <tr class="light-gray-top-border">
                <td class="p-1">نوع اشتراک</td>
                <td>نقره ای یک ماهه</td>
              </tr>
              <tr class="light-gray-top-border light-gray-bottom-border">
                <td class="p-1">تاریخ انقضا:</td>
                <td>{{ $convertDate(item.ExpireDate) }}</td>
              </tr>
              </tbody>
            </table>
            <div class="text-center col-12 ">
              <v-btn class="gradient-btn px-5" rounded small @click="goToPackageDetail(item.PackageID)">
               مشاهده
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-fab-transition>
      <v-btn
          id="memberShipFabBtn"
          color="forth"
          dark
          fab
          fixed
          left
          x-large
          @click="goToBuyMemberShip">

        <div class="fab-icon-text">خرید عضویت</div>
      </v-btn>
    </v-fab-transition>
    <FooterMenu :currentPage="'signUp'"/>
    <v-dialog
        v-model="showResultDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "Membership",
  metaInfo: {
    title: 'مسیربرتر-عضویت'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    items: [],
    dialogResult: null,
    showResultDialog: false,
    showLoaderDialog: false,
    historyItems: [],
    membershipHistory: true,
    activeMembership: false,
    hasActiveMembership: true,
    hasPackages: true,

  }),
  mounted() {
    _this = this;
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let now = this.$convertDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))

      let date = new Date()
      date.setFullYear(date.getFullYear() - 1)
      let yearAgo = this.$convertDate(new Date(date - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10))

      let urlencoded = new URLSearchParams();

      urlencoded.append("AppUserID", this.$getUserData().userID);
      urlencoded.append("StartDate", yearAgo);

      urlencoded.append("EndDate", now);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "PackageReportManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false
            let json = JSON.parse(result)
            json.sort(function (a, b) {
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(b.ModifiedDate) - new Date(a.ModifiedDate);
            });
            let activePackage = json.filter(x => x.IsExpire === false)
            if (activePackage.length === 0) {
              _this.hasActiveMembership = false;
            } else {
              _this.items = activePackage
              _this.hasActiveMembership = true
            }

            if (json.length === 0) {
              _this.hasPackages = false;
            } else {
              _this.historyItems = json
              _this.hasPackages = true
            }
          })
          .catch(error => console.log('error', error));
    },
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    goToPackageDetail(id) {
      this.$router.push({path: 'BuyMembershipPackageDetail', query: {PackageID: id}})
    },
    goToBuyMemberShip() {
      this.$router.push({path: 'BuyMembership'})
    },
    showMemberShipHistory() {
      this.membershipHistory = true;
      this.activeMembership = false;
    },
    showActiveMembership() {
      this.membershipHistory = false;
      this.activeMembership = true;
    }
  }
}
</script>

<style scoped>

</style>